import getBlogArticleBySlug from './getBlogArticleBySlug'
import getBlogArticles from './getBlogArticles'
import getBlogCategories from './getBlogCategories'
import getBlogExternalArticles from './getBlogExternalArticles'

const blog = {
  getBlogArticleBySlug,
  getBlogArticles,
  getBlogCategories,
  getBlogExternalArticles
}

export default blog
